var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVariableIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.26318 13.416C1.86768 12.2734 1.604 10.7061 1.604 8.77246C1.59668 5.55713 2.85645 2.68604 4.98779 0.583984H3.27393C1.31836 2.51025 0 5.42529 0 8.56738C0 10.3105 0.344238 12.3467 0.842285 13.416H2.26318Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44873 8.4209L8.63525 11.1528H10.2905L8.56934 7.36621L11.9165 3.42578H10.1221L7.87354 6.15771H7.84424L6.65039 3.42578H4.99512L6.72363 7.20508L3.36914 11.1528H5.1709L7.41211 8.4209H7.44873Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1616 0.583984C13.5571 1.72656 13.8208 3.29395 13.8208 5.22754C13.8281 8.44287 12.5684 11.314 10.437 13.416H12.1509C14.1064 11.4897 15.4175 8.57471 15.4175 5.43262C15.4175 3.68945 15.0806 1.66064 14.5752 0.583984H13.1616Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariableIcon);
export default __webpack_public_path__ + "static/media/variableIcon.52d49eb5.svg";
export { ForwardRef as ReactComponent };